import React from 'react';

import { COLORS } from '../../config/designSystem/Colors';
import { Caption1Bold } from '../../config/designSystem/typography';
import { SPACING } from '../../config/designSystem/Spacing';
import { StyleProp, TouchableOpacity,ViewStyle } from 'react-native';


interface ButtonProps {
  onPress: () => void;
  label: string;
  style?: StyleProp<ViewStyle>;

}

export const DesignSystemButtonTertiaryButton = ({ label, onPress, style}: ButtonProps) => {

  return (
    <TouchableOpacity
      style={[
        {
          borderColor: COLORS.border.accent,
          borderWidth: SPACING['sp-2'],
          paddingVertical: SPACING['sp-12'],
          paddingHorizontal: SPACING['sp-24'],
          borderRadius: SPACING['sp-24'],
          width:'100%',
          alignItems:'center'
        },
        style
      ]}
      onPress={onPress}
    >

      <Caption1Bold color={COLORS.content.accent}>{label}</Caption1Bold>
    </TouchableOpacity>
  );
};

